import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import appReducer from '../reducers';
import { analyticsMiddleware } from './analytics';

const middleware = [thunk, analyticsMiddleware];

export const store = configureStore({ reducer: appReducer, middleware });
